import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=9125b58e&scoped=true&lang=html&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9125b58e",
  null
  
)

export default component.exports